// extracted by mini-css-extract-plugin
export default {"slick-slide":"FooterBanner_slick-slide__J2gjc","footerBanner":"FooterBanner_footerBanner__l5iHM","adLogo":"FooterBanner_adLogo__7GlRC","pagination":"FooterBanner_pagination__R5V3O"};